import { Box, Card, HStack, Progress, VStack, Text, Skeleton, } from "@chakra-ui/react";
import { formatPrice, } from "../../../../utils/formatPrice.ts";
import { useParams, } from "react-router-dom";
import { useQuery, } from "@tanstack/react-query";
import { limitByIdQueryConfig, } from "../../../../api";

export function LimitMainInfo() {
  const limitId = useParams().id!;
  const { data, isLoading, } = useQuery(limitByIdQueryConfig(limitId,),);
  const availableAmount = data?.availableAmount ?? 0;
  const totalAmount = data?.totalAmount ?? 0;
  const progressValue = (availableAmount / totalAmount) * 100;

  return (
    <Skeleton isLoaded={!isLoading}>
      <Card variant="elevated" px={4} py={5}>
        <VStack alignItems="flex-start" gap="4" mb="1">
          <Box>
            <HStack>
              <Text fontSize="20px" fontWeight="bold">Доступный лимит</Text>
              <Text fontSize="20px" fontWeight="bold" color="brand.500">{data?.name}</Text>
            </HStack>
          </Box>
          <Box width="100%">
            <HStack display="flex" flexDir="row" justifyContent="space-between">
              <Text fontWeight="bold" fontSize="16px">{formatPrice(availableAmount, 0,)}</Text>
              <Text fontWeight="bold" fontSize="16px">{formatPrice(totalAmount, 0,)}</Text>
            </HStack>
          </Box>
        </VStack>
        <Progress
          value={progressValue}
          size="sm"
          borderRadius="full"
          colorScheme="purple"
          mt={1}
        />
      </Card>
    </Skeleton>
  );
}
